export default __webpack_public_path__ + "static/media/icono.4b9cc547.png";